import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BasicForm } from 'src/app/shared/basic-form';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent extends BasicForm implements OnInit {

  ngOnInit(): void {
    this.formAlias = 'ContactInfo';
    this.form = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      phone: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.minLength(9), Validators.maxLength(9)]],
    })
    this.form.patchValue(this.formData);
  }

}
